// extracted by mini-css-extract-plugin
module.exports = {"BucketListBlock":"BucketListBlock_BucketListBlock__UNl62","BucketListBlockItem":"BucketListBlock_BucketListBlockItem___FFU7","TitleCard":"BucketListBlock_TitleCard__cAONF"};